module.exports = __webpack_public_path__ + "static/oct_card-2d6f4f0ff08f11bb18c12edaef546eef.png";